import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { EditableFormField } from '../../interface';

@Injectable()
export class FormFieldEditorService {
  private fieldOpenForEditing$$ = new BehaviorSubject<EditableFormField | null>(null);
  fieldOpenForEditing$ = this.fieldOpenForEditing$$.asObservable();

  changeToField(newField: EditableFormField): void {
    this.fieldOpenForEditing$$.next(newField);
  }

  cancelEdits(): void {
    this.fieldOpenForEditing$$.next(null);
  }

  fieldIsCurrentlyOpenForEdits(field?: EditableFormField): Observable<boolean> {
    return this.fieldOpenForEditing$$.pipe(
      take(1),
      map((current) => {
        if (!current || !field) {
          return false;
        }
        return current.getFieldId() === field.getFieldId();
      }),
    );
  }
}
